import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { NotificationIdentifierModel } from '../../models/low-level/notification-identifier.model';
import {
    JsonNotificationUpdateModel,
    NotificationUpdateModel,
    NotificationUpdateModelFromJson,
} from '../../models/low-level/notification-update.model';
import { LocalStorageCommonService } from '../local-storage/local-storage-common.service';

const KEY_NEWUPDATES = 'newUpdates';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageNotificationUpdateService {
    public constructor(private localStorageCommonService: LocalStorageCommonService) {}

    public getLatestNewUpdate(
        notificationIdentifier: NotificationIdentifierModel,
    ): NotificationUpdateModel | undefined {
        let activeUpdates = this.getAllActiveNotificationUpdates(notificationIdentifier);
        if (activeUpdates.length === 0) {
            return;
        }

        // sort by timestamp descending. The most recent update at first position.
        activeUpdates = _.sortBy(activeUpdates, (update) => update.date.valueOf() * -1);

        return activeUpdates.shift();
    }

    private getAllActiveNotificationUpdates(
        notificationIdentifier: NotificationIdentifierModel,
    ): NotificationUpdateModel[] {
        const updates = this.getNotificationUpdates();

        // only get the updates for a specific notification and only the active ones.
        let filtered = updates.filter(
            (update) =>
                NotificationIdentifierModel.compare(update.notificationId, notificationIdentifier) && update.isActive,
        );

        // sort by timestamp descending. The most recent update at first position.
        filtered = _.sortBy(filtered, (update) => update.date.valueOf() * -1);

        return filtered;
    }

    public getNotificationUpdates(): NotificationUpdateModel[] {
        const updatesFromStorage =
            this.localStorageCommonService.storageGet<JsonNotificationUpdateModel[]>(KEY_NEWUPDATES) || [];
        return updatesFromStorage.map((u) => new NotificationUpdateModelFromJson(u));
    }

    public saveNotificationUpdates(updates: NotificationUpdateModel[]): void {
        this.localStorageCommonService.storageSet(KEY_NEWUPDATES, updates);
    }
}
